export const safeDecodeURIComponent = (value: string): string | null => {
  try {
    return decodeURIComponent(value);
  } catch {
    return null;
  }
};

export const normalizeResponseHeaderValue = (
  value: unknown
): string | undefined => {
  if (value == null) return undefined;
  if (Array.isArray(value)) {
    const first = value[0];
    return first == null ? undefined : String(first);
  }
  return String(value);
};

export const parseFileNameFromContentDisposition = (
  contentDisposition: string
): string | undefined => {
  const encodedFileNameMatch = contentDisposition.match(
    /filename\*=UTF-8''([^;]+)/i
  );
  if (encodedFileNameMatch?.[1]) {
    const rawEncodedName = encodedFileNameMatch[1].replace(/["']/g, "");
    const decodedName = safeDecodeURIComponent(rawEncodedName);
    if (decodedName) {
      return decodedName;
    }
    return rawEncodedName;
  }

  const quotedFileNameMatch = contentDisposition.match(/filename="([^"]+)"/i);
  if (quotedFileNameMatch?.[1]) {
    return quotedFileNameMatch[1];
  }

  const unquotedFileNameMatch = contentDisposition.match(/filename=([^;]+)/i);
  if (unquotedFileNameMatch?.[1]) {
    return unquotedFileNameMatch[1].trim();
  }

  return undefined;
};

const BLOB_DOWNLOAD_REVOKE_DELAY_MS = 2000;

export const triggerBlobDownload = (blob: Blob, fileName: string) => {
  const blobUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => {
    window.URL.revokeObjectURL(blobUrl);
  }, BLOB_DOWNLOAD_REVOKE_DELAY_MS);
};
